module.exports = __webpack_public_path__ + "static/media/Unduh.0e82dbb9.svg";